import React, { createRef, useState } from "react"
import { Popover } from "reactstrap"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import BootstrapTheme from "@fullcalendar/bootstrap"
import interactionPlugin from "@fullcalendar/interaction"
import listPlugin from "@fullcalendar/list"
import "bootstrap/dist/css/bootstrap.css"
import momentTimezonePlugin from "@fullcalendar/moment-timezone"
import { useEffect } from "react"

const Calendar = ({
  events = [],
  timeZone,
  updateSize,
  filterComponent,
  onEventClick = () => {},
}) => {
  const [filterToggle, setFilterToggle] = useState(false)
  const [filterTarget, setFilterTarget] = useState(null)
  const calendarRef = createRef()
  let timeOut = null

  const updateCalendarSize = () => {
    if (timeOut) {
      clearTimeout(timeOut)
    }
    timeOut = setTimeout(() => {
      calendarRef?.current?.getApi().updateSize()
    }, 700)
  }

  useEffect(() => {
    if (updateSize && calendarRef.current) {
      updateCalendarSize()
    }
  }, [updateSize, events])

  return (
    <React.Fragment>
      <FullCalendar
        ref={calendarRef}
        viewClassNames="custom-grid"
        plugins={[
          BootstrapTheme,
          dayGridPlugin,
          interactionPlugin,
          listPlugin,
          momentTimezonePlugin,
        ]}
        handleWindowResize={true}
        themeSystem="bootstrap"
        businessHours={true}
        dayHeaderClassNames={"calendar-day-header"}
        // customButtons={{
        //   filterButton: {
        //     text: "Filter",
        //     click: (event, target) => {
        //       setFilterTarget(target)
        //       setFilterToggle(!filterToggle)
        //     },
        //   },
        // }}
        headerToolbar={{
          start: `prev,next today`, //filterButton
          center: "title",
          end: "dayGridMonth,dayGridWeek,dayGridDay,listWeek",
        }}
        events={events}
        height="auto"
        timeZone={timeZone}
        dayMaxEventRows={true}
        views={{
          dayGrid: {
            dayMaxEventRows: 5,
          },
        }}
        datesSet={dateInfo => {
          updateCalendarSize()
        }}
        eventClick={info => {
          onEventClick(info)
        }}
      />
      {filterTarget && (
        <Popover
          isOpen={filterToggle}
          target={filterTarget}
          toggle={() => {
            setFilterToggle(!filterToggle)
          }}
          placement="bottom"
        >
          {filterComponent}
        </Popover>
      )}
    </React.Fragment>
  )
}

export default Calendar
